import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@/core/api/type'
import { GetTOTPGenerate } from '@/modules/profile/types'
import { getTOTPGenerate } from '../../services'
import { ProfileQueryKey } from '@/modules/profile/keys'

export default function useQueryGetTOTPGenerate(
	id: string,
	props?: UseBaseQueryOptions<GetTOTPGenerate>,
) {
	return useQuery({
		queryKey: [ProfileQueryKey.GetTOTPGenerate, id],
		queryFn: () => getTOTPGenerate(id),
		enabled: false,
		staleTime: Infinity,
		...props,
	})
}
